'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.noData = noData;
function noData() {
  var _console;

  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  (_console = console).warn.apply(_console, ['No data was passed to chart! If this was intentional, disregard this warning.'].concat(args));
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-charts/es/utils/Debug.js
// module id = 1409
// module chunks = 0